import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

const notifyPeople = async (noteIds: number[]) => {
  try {
    const response = await sendRequest({
      url: endpoints.disciplinaryActions.notifyPeople,
      method: 'POST',
      body: { noteIds },
      credentials: 'include',
    });
    return response;
  } catch (error) {
    console.error('Error notifying people:', error);
    throw error;
  }
};

export const useNotifyPeople = () =>
  useMutation({
    mutationFn: (noteIds: number[]) => notifyPeople(noteIds),
  });
